import { materialSymbols } from "../../../../../shared/constants/material-symbols";
import { IVoteOption } from "../../../../../shared/models/ballot-vote";


export enum SrsVoteId {
  SVT_RECONFIRM = "SVT_RECONFIRM",
  SVT_REVISE = "SVT_REVISE",
  SVT_WITHDRAW = "SVT_WITHDRAW",
  SVT_NONE = "SVT_NONE"
}

export const srsVoteOption: { [key: string]: IVoteOption } = {
  "SVT_RECONFIRM": {color: '#1A936F', icon: materialSymbols.checkCircle, text: 'Reconfirm'},
  "SVT_REVISE": {color: '#007AC9', icon: materialSymbols.refresh, text: 'Revise'},
  "SVT_WITHDRAW": {color: '#595959', icon: materialSymbols.logout, text: 'Withdraw'},
  "SVT_NONE": {color: '#FFB500', icon: materialSymbols.removeCircle, text: 'No Response'}
}

export interface ISrsBallotVote {
  id: string;
  ballotId: string;
  voteTypeId: string;
  hasAuthorisationDocument: boolean;
  hasSupportingInformationDocument: boolean;
  userName: string;
  email: string;
  country: string;
  organisation: string;
  role: string;
  lastUpdated?: Date;
  submitted?: Date;
  comments: ISrsBallotVoteComment[];
  isCurrentUserEligibleVoter: boolean;
  isEligible: boolean;
  votingRights: string;
}

export interface ISrsBallotVoteComment {
  id: string;
  created: Date;
  lastUpdated: Date;
  comment: string;
  voteResult: string;
  submitted: Date;
  currentPublicationConfirmation?: boolean;
  leadProjectProposal?: boolean;
}

